export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function encode(str: string): string {
  return btoa(unescape(encodeURIComponent(str || "")));
}

export function decode(bytes: string): string {
  var escaped = escape(atob(bytes || ""));
  try {
    return decodeURIComponent(escaped);
  } catch {
    return unescape(escaped);
  }
}
